import * as types from './mutation-types';

export default {
  async getUserInfo({ commit, state }, checkAuth = true, from = '') {
    commit();
    console.log(types, state, checkAuth, from);
  },

  clearStoreUserInfo({ commit }) {
    commit();
  },

  async getReduceInfo({ commit }) {
    commit();
  },

  async getDownloadCount({ commit }) {
    commit();
  },

  async getScenarioCategory({ commit }) {
    commit();
  },
};
